import { Plus, Trash } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

/**
 * Manage-Recruiters dialog. Owner can add/remove; non-owner sees a read-only list.
 *
 * The parent passes the data + handlers — this component is purely presentational.
 */
export const RecruitersDialog = ({
  open, onOpenChange,
  recruiters,
  isOwner,
  newRecruiter, setNewRecruiter,
  onAddRecruiter,
  onDeleteRecruiter,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      className="bg-[#0F3622] border-2 border-[#A3E635] shadow-[6px_6px_0px_0px_rgba(163,230,53,0.4)] sm:max-w-[500px]"
      data-testid="manage-recruiters-dialog"
    >
      <DialogHeader>
        <DialogTitle className="text-2xl font-bold text-white" style={{fontFamily: 'Cabinet Grotesk, sans-serif'}}>
          Manage Recruiters
        </DialogTitle>
        <DialogDescription className="sr-only">Add or remove recruiters</DialogDescription>
      </DialogHeader>

      {isOwner ? (
        <form onSubmit={onAddRecruiter} className="flex gap-2 mb-2">
          <Input
            data-testid="new-recruiter-input"
            placeholder="Add a recruiter (e.g. Rohit Verma)"
            value={newRecruiter}
            onChange={(e) => setNewRecruiter(e.target.value)}
            className="flex-1 bg-white border-2 border-[#A3E635] rounded-md px-3 py-2 text-black"
          />
          <Button
            type="submit"
            data-testid="submit-new-recruiter"
            className="bg-[#A3E635] text-black border-2 border-[#A3E635] rounded-md font-bold px-4 py-2 shadow-[2px_2px_0px_0px_rgba(163,230,53,0.5)] hover:-translate-y-0.5 hover:shadow-[3px_3px_0px_0px_rgba(163,230,53,0.7)] transition-all"
          >
            <Plus size={16} weight="bold" className="mr-1" />
            Add
          </Button>
        </form>
      ) : (
        <p className="text-sm text-white italic">Read-only — only the Owner can add or remove recruiters.</p>
      )}

      <div className="border-t-2 border-[#143E29] pt-3 max-h-64 overflow-y-auto" data-testid="recruiters-list">
        {recruiters.length === 0 ? (
          <p className="text-sm text-white text-center py-4">No recruiters yet.</p>
        ) : (
          recruiters.map((r) => (
            <div key={r.id} className="flex items-center justify-between bg-[#0B2818] border-2 border-[#143E29] rounded-md px-3 py-2 mb-2">
              <span className="font-bold text-white">{r.name}</span>
              {isOwner && (
                <button
                  data-testid={`delete-recruiter-${r.id}`}
                  onClick={() => onDeleteRecruiter(r)}
                  title="Remove recruiter"
                  className="p-1.5 bg-[#F87171] text-white border-2 border-black rounded hover:-translate-y-0.5 hover:shadow-[2px_2px_0px_0px_rgba(10,10,10,1)] transition-all"
                >
                  <Trash size={14} weight="bold" />
                </button>
              )}
            </div>
          ))
        )}
      </div>
    </DialogContent>
  </Dialog>
);
